import { render, staticRenderFns } from "./hsnp_wizard_step_02_minpurchase.vue?vue&type=template&id=2a28a3ad&scoped=true"
import script from "./hsnp_wizard_step_02_minpurchase.vue?vue&type=script&lang=js"
export * from "./hsnp_wizard_step_02_minpurchase.vue?vue&type=script&lang=js"
import style0 from "./hsnp_wizard_step_02_minpurchase.vue?vue&type=style&index=0&id=2a28a3ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28a3ad",
  null
  
)

export default component.exports